module.exports = __webpack_public_path__ + "static/media/IMG_023.52208189.JPG";